import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";

const ContactInfo = () => {
    return (
        <div className="container py-5">
            <div className="row justify-content-center">
                
                <div className="col-md-4">
                    <div className="contact-card">
                        <div className="icon-box">
                            <img src="https://img.icons8.com/ios-filled/50/ffffff/new-post.png" alt="Email" />
                        </div>
                        <h4 className="contact-title">Adresse E-Mail</h4>
                        <p>Vous avez des questions ? Contactez-nous par e-mail pour une assistance rapide et fiable.</p>
                        <a href="mailto:info@domainname.com" className="contact-link">
                            expertises@cinef-expertises.com
                        </a>
                    </div>
                </div>

              
                <div className="col-md-4">
                    <div className="contact-card">
                        <div className="icon-box">
                            <img src="https://img.icons8.com/ios-filled/50/ffffff/phone.png" alt="Phone" />
                        </div>
                        <h4 className="contact-title">Besoin d'aide ?</h4>
                        <p>Nous sommes là pour vous aider ! Contactez-nous dès aujourd'hui pour toute demande ou assistance.</p>
                        <a href="tel:+91123456789" className="contact-link">
                            +229 01 97 08 46 01
                        </a>
                    </div>
                </div>

               
                <div className="col-md-4">
                    <div className="contact-card">
                        <div className="icon-box">
                            <img src="https://img.icons8.com/ios-filled/50/ffffff/marker.png" alt="Location" />
                        </div>
                        <h4 className="contact-title">Adresse du bureau</h4>
                        <p>Venez nous rendre visite à notre adresse pour une assistance personnalisée.</p>
                        <a href="https://www.google.com/maps/place/Cinef+Formation+Professionnelle+Au+Benin/@6.3806348,2.3982606,17z/data=!3m1!4b1!4m6!3m5!1s0x102355c003d8ae37:0x4e8a4e13d75c13c4!8m2!3d6.3806295!4d2.4008355!16s%2Fg%2F11gfd6n38w?hl=ru&entry=ttu&g_ep=EgoyMDI1MDUwNS4wIKXMDSoASAFQAw%3D%3D" className="contact-link" target="_blank" rel="noopener noreferrer">
                            Sainte Rita, Cotonou -  Bénin
                        </a>
                    </div>
                </div>
            </div>

            {/* Styles CSS */}
            <style>{`
                .contact-card {
                    background: #fff;
                    padding: 30px;
                    text-align: center;
                    border-radius: 10px;
                    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
                    transition: transform 0.3s ease-in-out;
                }

                .contact-card:hover {
                    transform: translateY(-5px);
                }

                .icon-box {
                    width: 60px;
                    height: 60px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    background: linear-gradient(to right, #d53369, #daae51);
                    border-radius: 10px;
                    margin: auto;
                    margin-bottom: 20px;
                }

                .icon-box img {
                    width: 30px;
                    height: 30px;
                }

                .contact-title {
                    font-size: 20px;
                    font-weight: bold;
                    color: #111;
                }

                .contact-link {
                    color: #5e3bee;
                    font-weight: bold;
                    text-decoration: none;
                    transition: color 0.3s ease-in-out;
                }

                .contact-link:hover {
                    color: #d53369;
                }

                @media (max-width: 768px) {
                    .contact-card {
                        margin-bottom: 20px;
                    }
                }
            `}</style>
        </div>
    );
};

export default ContactInfo;